import { Link } from 'react-router-dom';

import SkillCardRow, { SkillCardRowProps } from './SkillCardRow';
import CreateNewSkillCard from '../../components/molecules/CreateNewSkillCard';

import './SkillCardRow.scss';

export default function SkillCardRowWithAdd(props: SkillCardRowProps) {
  return (
    <SkillCardRow {...props}>
      <li>
        <Link to="/create-edit-skill">
          <CreateNewSkillCard className="h-full" />
        </Link>
      </li>
    </SkillCardRow>
  );
}
